export default __webpack_public_path__ + "static/media/12.9bec92da.jpg";